export const MENU_ITEM_TYPES = {
    LINK: 'link',
    SUBMENU: 'submenu',
    SEPARATOR: 'separator'
};
